export const HTTP_STATUS = {
  OK: 200,
  MULTIPLE_CHOICES: 300,
  UNAUTHORIZED: 401,
  INTERNAL_SERVER_ERROR: 500,
};
